// ============================================================
// components/Toast.jsx — Notification Toast
// ============================================================

import React from "react";

export default function Toast({ toast }) {
  if (!toast) return null;

  return (
    <div className={`toast show ${toast.type || ""}`}>
      {toast.msg}
    </div>
  );
}
